import { ActionType } from '../../types';

export const ResetSuggestionActions = {
      resetUserSuggestionStarted: () =>
        ({
            type: 'ResetSuggestion/Load/Started',
        } as const),

    resetUserSuggestionSucceeded: () =>
        ({
            type: 'ResetSuggestion/Load/Succeeded',
        } as const),

    resetUserSuggestionFailed: (errorCode: string) =>
        ({
            type: 'ResetSuggestion/Load/Failed',
            payload: { errorCode },
        } as const),
    resetUserSuggestionUnmounted: () =>
        ({
            type: 'ResetSuggestion/Load/Unmounted',
        } as const),
};

export type ResetSuggestionActions = ActionType<typeof ResetSuggestionActions>;
